/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DemandeValidationListItemDto } from './DemandeValidationListItemDto';
import {
    DemandeValidationListItemDtoFromJSON,
    DemandeValidationListItemDtoFromJSONTyped,
    DemandeValidationListItemDtoToJSON,
    DemandeValidationListItemDtoToJSONTyped,
} from './DemandeValidationListItemDto';

/**
 * Page of the validator inbox; facets have their own endpoint (liste/filtres).
 * @export
 * @interface ListDemandesValidationResponse
 */
export interface ListDemandesValidationResponse {
    /**
     * 
     * @type {Array<DemandeValidationListItemDto>}
     * @memberof ListDemandesValidationResponse
     */
    items: Array<DemandeValidationListItemDto>;
    /**
     * 
     * @type {number}
     * @memberof ListDemandesValidationResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListDemandesValidationResponse interface.
 */
export function instanceOfListDemandesValidationResponse(value: object): value is ListDemandesValidationResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function ListDemandesValidationResponseFromJSON(json: any): ListDemandesValidationResponse {
    return ListDemandesValidationResponseFromJSONTyped(json, false);
}

export function ListDemandesValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDemandesValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DemandeValidationListItemDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function ListDemandesValidationResponseToJSON(json: any): ListDemandesValidationResponse {
    return ListDemandesValidationResponseToJSONTyped(json, false);
}

export function ListDemandesValidationResponseToJSONTyped(value?: ListDemandesValidationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DemandeValidationListItemDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

